/*
 * Created Date: 14-01-2023, 10:38:47 pm
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

class LevelSchool extends BaseService {
	BASE_ENDPOINT = '/quiz/api/v1/user/exams/level-school'

	/**
	 * Get all resource for paginate
	 * @param {}
	 * @returns
	 */
	list = (query = {}, config = {}) => {
		const params = { ...this.paramsGet, ...query }
		return this.withCache(() => this.request.get(this.BASE_ENDPOINT, { params, ...config }), this.BASE_ENDPOINT)
	}
}

export const levelSchoolService = new LevelSchool()
